import PropTypes from 'prop-types';
import React from 'react';

import IconButton from 'components/IconButton';
import Theme from 'styles/theme';

const Backdrop = props => {
  const { show, zIndex, ...otherProps } = props;

  return (
    show && (
      <div className="Backdrop">
        <IconButton className="Backdrop__button" {...otherProps}>
          <div className="Backdrop__content" />
        </IconButton>
        <style jsx>
          {`
            .Backdrop__content {
              position: fixed;
              top: 0;
              right: 0;
              bottom: 0;
              left: 0;
              z-index: ${zIndex};
              background-color: ${Theme.get('colors-black-transparent')};
              animation: ${Theme.get('transition-duration-ms')} fadeIn;
            }

            @keyframes fadeIn {
              from {
                opacity: 0;
              }
              to {
                opacity: 1;
              }
            }
          `}
        </style>
        <style jsx global>
          {`
            .IconButton.Backdrop__button {
              min-width: 0;
              min-height: 0;
            }
          `}
        </style>
      </div>
    )
  );
};

Backdrop.propTypes = {
  show: PropTypes.bool,
  zIndex: PropTypes.number,
};

Backdrop.defaultProps = {
  show: false,
  zIndex: Theme.get('z-index-top-navigation-backdrop'),
};

export default Backdrop;
